<template>
  <div style="min-height: 100px;" class="leftTree">
    <el-tree
      v-if="isLookRecord"
      :data="lookRecordTree"
      :props="defaultProps"
      @node-click="lookRecordTreeClick"
      @node-contextmenu="rightClick1"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>
          <img v-if="data.ICON" :src="isIcon(data.ICON)" alt style="width: 18px;height: 18px;">
          {{ node.label }}
        </span>
      </span>
    </el-tree>
    <el-tree
      :highlight-current="hhh"
      default-expand-all
      :data="treeDataLeft"
      :default-checked-keys="list"
      node-key="id"
      ref="treeLeft"
      :render-after-expand="false"
      :props="defaultProps"
      draggable
      :allow-drop="allowDrop"
      :allow-drag="allowDrag"
      @node-drop="handleDrop2"
      @node-click="handleNodeClick"
      @node-contextmenu="rightClickLeft"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>
          <img v-if="data.ICON" :src="isIcon(data.ICON)" alt style="width: 18px;height: 18px;">
          {{ node.label }}
        </span>
      </span>
    </el-tree>
    <div :id="'rClickLeft-'+index" v-show="rClickLeft" class="rClickLeft" ref="rClickLeft">
      <rightClick
        @newClassClick="newClassClick"
        @newTemp="newTemp"
        @amendSeek="amendSeekLeft"
        @rcHuidiao="rcHuidiao"
        :treeObj="thisTreeObj"
        :treeNode="thisTreeNode"
        :isLeft="true"
        :isBlank="isBlank"
        ref="rightClick"
      ></rightClick>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {
  UpdateTemplateOrderIndex,
  GetAllVisibleTemplateByUserId,
  UpdateTemplateOrder
} from "@/api/modules/basicData/task";
import { listToTree } from "@/api/modules/basicData/commonData";
// import searchJs from '@/util/search';
import rightClick from "./rightClick.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      list: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      thisTreeObj: {},
      thisTreeNode: {},
      // lookRecordTree: [],
      // treeDataLeft: [],
      rClickLeft: false,
      index: 0
    };
  },
  props: {
    isBlank: {
      type: Boolean,
      default: false
    }
  },
  components: {
    rightClick,
    draggable
  },
  computed: {
    hhh: function() {
      return this.$store.state.template.hhh;
    },
    userId: function() {
      return this.$store.state.task.userId;
    },
    isLookRecord: function() {
      return this.$store.state.template.isLookRecord;
    },
    lookRecordTree: function() {
      return this.$store.state.template.lookRecordTree;
    },
    treeDataLeft: function() {
      return this.$store.state.template.treeDataLeft;
    }
  },
  mounted() {
    this.index = document.querySelectorAll(".rClickLeft").length || 0;
  },
  methods: {
    newClassClick() {
      this.$emit("newClassClick");
    },
    newTemp() {
      this.$emit("newTemp");
    },
    rcHuidiao() {
      this.$emit("getAllClass");
    },
    amendSeekLeft(data) {
      this.$emit("leftSearch", data);
    },
    isIcon(val) {
      if (val) {
        return require("@/assets/icon/" + val);
      }
    },
    lookRecordTreeClick(data) {
      this.$emit("event1", data);
      // 浏览记录
      this.$store.dispatch("changePageSize", {
        size: this.$store.state.task.pageSize,
        type: 2
      });
      this.$store.state.task.type = 2;
    },
    handleNodeClick(data) {
      this.$emit("event1", data);
    },
    rightClickLeft(ev, data, node, val) {
      console.log("asd",ev, data, node, val);
      //右击
      // let dom = document.getElementById("rClickLeft-" + this.index);
      this.rClickLeft = true;
      // dom.style.top = ev.pageY + "px";
      // dom.style.left = ev.pageX + "px";
      this.$refs.rClickLeft.style.top = ev.clientY + "px";
      this.$refs.rClickLeft.style.left = ev.clientX + "px";
      
      // dom.style.display = 'block';
      this.thisTreeObj = data;
      this.thisTreeNode = node;
      let _this = this;
      document.onclick = function() {
        _this.rClickLeft = false;
      };
    },
    rightClick1() {}, //不可删
    handleDrop2(draggingNode, dropNode, dropType, ev) {
      //拖拽结束调用
      let pid = null;
      console.log(this.treeDataLeft, "treeDataLeft");
      if (draggingNode.data.TEMPTYPE !== 2) {
        if (dropNode.data.PID) {
          pid = dropNode.data.PID;
        } else {
          pid = dropNode.data.ID;
        }
      }

      let arr = dropNode.parent.childNodes;
      let temObj = draggingNode.data;
      let temIndex = null;
      for (let [index, val] of arr.entries()) {
        if (temObj.ID == val.data.ID) {
          temIndex = index;
        }
      }
      var formData = new FormData();

      let arrRet = this.translateTreeData(this.treeDataLeft);
      UpdateTemplateOrder(arrRet, this.userId).then(res => {});
    },
    translateTreeData(treeData) {
      let arrRet = [];
      this.func1(treeData, arrRet);
      return arrRet;
    },
    func1(treeData, arr, pid) {
      if (!treeData || treeData.length == 0) return;
      for (let i = 0; i < treeData.length; i++) {
        treeData[i].PID = pid;
        arr.push(treeData[i]);
        let treeData1 = treeData[i].children;
        this.func1(treeData1, arr, treeData[i].ID);
      }
    },
    allowDrop(draggingNode, dropNode, type) {
      console.log("目标节点", type);
      //设置拖拽规则
      // console.log('draggingNode:',draggingNode);
      // console.log('dropNode:',dropNode);
      if (draggingNode.data.PID && dropNode.data.PID) {
        // 拖拽的不是父节点，目标位置也不是父节点，不放在节点内部
        // if (
        //   draggingNode.data.ROLETYPE == 2 &&
        //   dropNode.parent.data.TEMPTYPE !== 4
        // ) {
        //   //拖拽的系统模板，目标位置不是系统分组，返回false
        //   return true;
        // } else {
        return type !== "inner";
        // }
      } else if (!draggingNode.data.PID && !dropNode.data.PID) {
        return type !== "inner"; //  拖拽的是父节点，目标位置也是父节点，不放在内部
      } else if (!draggingNode.data.PID && dropNode.data.PID) {
        return false; // 拖拽的是父节点，目标位置不是父节点
      } else if (draggingNode.data.PID && !dropNode.data.PID) {
        // 拖拽的不是父节点，目标位置是父节点，放在节点内部
        // if (draggingNode.data.ROLETYPE == 2 && dropNode.data.TEMPTYPE !== 4) {
        //   return true;
        // } else {
        return type == "inner";
        // }
      } else {
        return true;
      }
    },
    allowDrag(draggingNode) {
      //设置不可拖拽节点
      // if (draggingNode.data.ROLETYPE === 2 && this.userId !== "super") {
      //   return false;
      // } else {
      return true;
      // }
    }
  }
};
</script>

<style scoped>
.rClickLeft {
  position: fixed;
  top: 100px;
  left: 0;
  z-index: 99;
}
.leftTree .el-tree {
  color: #1e5297;
  letter-spacing: 0.6px;
}
</style>
